'use client';
import type { NextPage } from 'next';
import { ChangeEvent } from 'react';
import styles from './a-i-field.module.scss';
// import ButtonVoices from '../ButtonVoice/ButtonVoice';
import { AIFieldType } from '@/types/heroBlock.types';

const VoiceInput: NextPage<AIFieldType> = ({
  className = '',
  property1 = 'Default',
  placeholder = 'Select city and airport',
  label,
  value = '',
  onChange,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  const startListening = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });

      if (
        'webkitSpeechRecognition' in window ||
        'SpeechRecognition' in window
      ) {
        const SpeechRecognition =
          window.webkitSpeechRecognition || window.SpeechRecognition;
        const recognition = new SpeechRecognition();

        recognition.lang = 'en-US';
        recognition.continuous = false;
        recognition.interimResults = false;

        recognition.onstart = () => {
          // Voice recognition started
        };

        recognition.onresult = (event) => {
          const transcript = event.results[0][0].transcript;
          onChange?.(transcript);
        };

        recognition.onerror = (event) => {
          if (event.error === 'not-allowed') {
            alert('Please allow access to the microphone');
          } else if (event.error === 'aborted') {
            // Just stop listening without showing error
          } else {
            console.error('Speech recognition error:', event.error);
          }
        };

        recognition.onend = () => {
          // Voice recognition ended
        };

        recognition.start();
      } else {
        alert('Speech recognition is not supported in your browser.');
      }
    } catch {
      alert('Please allow access to the microphone');
    }
  };

  return (
    <div className={[styles.root, className].join(' ')}>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles['input-container']} data-property1={property1}>
        <input
          className={styles.input}
          placeholder={placeholder}
          type="text"
          disabled={property1 === 'Disabled'}
          value={value}
          onChange={handleChange}
        />
        <div onClick={startListening}>
          {/* <ButtonVoices
            property1={isListening ? 'Active' : 'Normal'}
            buttonVoicesOpacity={isListening ? 1 : 0.5}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default VoiceInput;
